// extracted by mini-css-extract-plugin
module.exports = {"desktop_wrapper":"dd31006766--desktop_wrapper--r9T8y","mobile_wrapper":"dd31006766--mobile_wrapper--MgZnV"};